import {isEmpty} from 'lodash';
import moment from 'moment';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchUserIfNeeded} from '../../../../../actions/app/support/user';
import {fetchUser} from '../../../../../actions/entities/user';
import {getEndpoint, getHeaders} from '../../../../../helpers/endpoint';
import TableRow from '../../../components/TableRow';
import SupportTitle from '../../../components/title';
import UserPurchases from '../Purchases';

const gameOptions = [
  'autocoach',
  'friday_brief',
  'no_ads',
  'live_rating',
  'bundle_02',
];

export const creditTimedOption = (userId, optionId) => {
  return (dispatch, getState) => {
    fetch(getEndpoint('creditTimedOption', userId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({productId: optionId}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.error}<br/>`,
          });
        } else {
          dispatch(fetchUserIfNeeded({identifier: userId}));
        }
      })
      .catch(error => {
        swal({
          title: `Oops...`,
          type: 'error',
          html: `Something went wrong !<br/>${error}<br/>`,
        });
      });
  };
};

export const editMoney = (userId, newMoney, onSuccess = () => {}) => {
  return (dispatch, getState) => {
    fetch(getEndpoint('editMoney', userId), {
      method: 'PATCH',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({newMoney}),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.error}<br/>`,
          });
        } else {
          onSuccess();
          dispatch(fetchUser({identifier: userId}));
        }
      })
      .catch(error => {
        swal({
          title: `Oops...`,
          type: 'error',
          html: `Something went wrong !<br/>${error}<br/>`,
        });
      });
  };
};

class UserBusiness extends React.Component {
  constructor(props) {
    super(props);

    const applicationsData = props?.user?.applicationsData?.mpg
      ? props?.user?.applicationsData?.mpg
      : props?.user?.applicationsData?.mpm;

    this.state = {
      money: applicationsData?.money || 0,
      editingMoney: false,
      applicationsData,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.applicationsData !== nextProps.applicationsData) {
      this.setState({
        money: nextProps.applicationsData?.money || 0,
        editingMoney: false,
        applicationsData: nextProps.applicationsData,
      });
    }
  }

  render() {
    const {dispatch, user} = this.props;
    const {money, editingMoney, applicationsData} = this.state;

    const renderMoney = () => {
      if (editingMoney) {
        return (
          <input
            type="number"
            onChange={e => this.setState({money: e.target.value})}
            style={{minWidth: 50, color: 'black'}}
            value={money}
          />
        );
      }
      return parseInt(money, 10).toLocaleString();
    };

    const onSuccess = () => {
      this.setState({editingMoney: false});
    };

    return (
      <div>
        <SupportTitle title="Business" />
        <UserPurchases user={user} />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexWrap: 'wrap',
          }}>
          {gameOptions?.map(optionId => (
            <button
              key={optionId}
              style={{margin: 8}}
              onClick={() => {
                dispatch(creditTimedOption(user.id, optionId));
              }}
              className="btn btn-info">{`Add ${optionId}`}</button>
          ))}
        </div>
        <table className="table table-sm table-responsive table-striped">
          <thead>
            <tr>
              <th>Key</th>
              <th>Value</th>
            </tr>
          </thead>
          <tbody>
            {!isEmpty(applicationsData?.gameOptions) &&
              Object.keys(applicationsData?.gameOptions)?.map(optionId => (
                <TableRow
                  key={optionId}
                  label={optionId}
                  value={moment(
                    applicationsData?.gameOptions?.[optionId],
                  )?.format('DD/MM/YY, HH:mm')}
                />
              ))}
            <TableRow />
            <TableRow
              label="Has been expert"
              value={applicationsData?.hasBeenExpert === 1 ? 'yes' : 'no'}
            />
            <TableRow
              label="Amount"
              value={parseInt(
                applicationsData?.amount || 0,
                10,
              ).toLocaleString()}
            />
            <TableRow
              label="App paid"
              value={applicationsData?.paidApp === 1 ? 'yes' : 'no'}
            />
            <TableRow
              label="Money"
              value={renderMoney()}
              action={
                <button
                  className={`btn ${
                    !editingMoney ? 'btn-success' : 'btn-warning'
                  }`}
                  onClick={() =>
                    editingMoney
                      ? dispatch(editMoney(user.id, money, onSuccess))
                      : this.setState({editingMoney: true})
                  }>
                  {editingMoney ? 'Validate' : 'Edit'}
                </button>
              }
            />
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(UserBusiness);



// WEBPACK FOOTER //
// ./src/pages/Support/User/components/Business/index.js